import { ENABLE_MOCK_AUTH } from '@/shared/config/dev-mocks'

/**
 * Утилиты для работы с аутентификацией
 */

/**
 * Проверяет, авторизован ли пользователь
 * 
 * Пользователь считается авторизованным, если есть непустой initData от Telegram.
 * В режиме разработки с включенными моками всегда возвращает true.
 * 
 * @param initData - initData строка от Telegram Web App SDK
 * @returns true если пользователь авторизован, false в противном случае
 * 
 * @example
 * ```ts
 * const { initData } = useTelegram()
 * if (isAuthenticated(initData)) {
 *   // Пользователь авторизован
 * }
 * ```
 */
export function isAuthenticated(initData: string | null | undefined): boolean {
  // В режиме моков всегда считаем пользователя авторизованным
  if (ENABLE_MOCK_AUTH) {
    return true
  }
  
  return Boolean(initData && initData.length > 0)
}

/**
 * Создает URL для редиректа с сохранением текущего пути
 * 
 * Используется для сохранения текущего маршрута при редиректе на страницу авторизации.
 * Путь кодируется в query параметр `redirect`.
 * 
 * @param currentPath - текущий путь, который нужно сохранить
 * @returns URL с закодированным путем в query параметре redirect
 * 
 * @example
 * ```ts
 * const redirectUrl = createRedirectUrl('/catalog/tea')
 * // "/profile?redirect=%2Fcatalog%2Ftea"
 * 
 * // После авторизации можно использовать:
 * const redirect = new URLSearchParams(window.location.search).get('redirect')
 * navigate({ to: redirect || '/' })
 * ```
 */
export function createRedirectUrl(currentPath: string): string {
  const encodedPath = encodeURIComponent(currentPath)
  return `/profile?redirect=${encodedPath}`
}

